<script>
  import GeneralButton from "./GeneralButton.svelte";

  /**
   * @type {"primary"|"secondary"|"negative"}
   */
  export let type = "primary"

  /**
   * @type {(e: Event) => void}
   */
  export let onClick

  /**
   * @type {boolean}
   */
  export let disabled = false

  /**
   * Extra styles to be injected into the button
   * @type {string}
   */
  export let style = ""

  /**
   * Button size
   * @type {"small"|"medium"|"large"}
   */
  export let size = "medium"
</script>

<GeneralButton
  buttonType={type}
  buttonFunction={onClick}
  buttonDisabled={disabled}
  buttonExtraStyle={style}
  buttonSize={size}
>
  <slot />
</GeneralButton>
